import type { Campaigns_FindCampaign_FindCampaignQueryResponse } from "../../swagger-types/v1/index.js";

interface CampaignsMock {
  campaignName: string;
  partnerId: number;
}

export const getCampaignsMock = ({ campaignName, partnerId }: CampaignsMock) => {
  return {
    campaign: {
      id: 609,
      name: campaignName,
      partnerId: partnerId,
      currencyCode: "USD",
      languageCode: "EN",
      uiSettings: {},
    },
  } satisfies Campaigns_FindCampaign_FindCampaignQueryResponse;
};
